export default __webpack_public_path__ + "static/media/cotton.e385114a.webp";